module.exports = __webpack_public_path__ + "static/icon1_how_it_works-e8ba90609725293a09ca0f20967c6040.png";